<template>
  <div class="flex flex-column">
    <button :disabled="chat.queue !== 'new' || !profile.iam.chatWrite" class="action" @click="assign()">
      <svg width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#00A1D4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.94 14.813A9.21 9.21 0 0 1 6.5 14.5l-5 2 2-3.5C1.926 11.741 1 9.875 1 7.934 1 4.105 4.805 1 9.5 1 14.194 1 18 4.105 18 7.934"/>
          <path d="M10 16.5c0 4.287 5 7.5 9.5 5.5l4 1.5-1.5-3c1.296-1.038 2-2.403 2-4 0-3.155-3.134-6-7-6s-7 2.845-7 6z"/>
        </g>
      </svg>
      Ota käsittelyyn
    </button>
    <button class="action" @click="showContentModal()">
      <svg width="24" height="20" viewBox="0 0 24 20" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#00A1D4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.629 16c0-1.934-1.566-3.5-3.5-3.5a3.5 3.5 0 1 0 3.5 3.5z"/>
          <path d="M13.129 10L23.37 3.912c-.56-.951-1.953-1.31-2.905-.75l-15.91 9.364M7.629 4a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"/>
          <path d="M11.02 8.731l12.352 7.355c-.561.951-1.954 1.312-2.907.75L4.628 7.5"/>
        </g>
      </svg>
      Kopioi tekstiä
    </button>
    <button class="action" :disabled="chat.queue !== 'own' || !profile.iam.chatWrite || (chat.status !== profile.userId && !profile.admin)" @click="queueSession()">
      <svg width="23" height="20" viewBox="0 0 23 20" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#00A1D4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
          <path d="M.5 6.994l3 4.5 3.5-4"/>
          <path d="M13 19.5c5.247 0 9.5-4.252 9.5-9.5a9.5 9.5 0 0 0-19 0v1.494"/>
        </g>
      </svg>
      Palauta jonoon
    </button>
    <button class="action" :disabled="chat.queue !== 'own' || !profile.iam.chatWrite || chat.status !== profile.userId" @click="showQuestionnaireModal()">
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#00A1D4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 8.5l-7.5 7L7 13"/>
          <path d="M23.5 12c0 6.352-5.15 11.5-11.5 11.5C5.647 23.5.5 18.352.5 12S5.647.5 12 .5C18.35.5 23.5 5.648 23.5 12z"/>
        </g>
      </svg>
      Sulje keskustelu
    </button>

    <modal v-show="isContentModalVisible" variant="large" @close="closeContentModal">
      <template slot="header">Kopioi tekstiä</template>
      <template slot="body">
        <p class="mb2 mt0">Voit maalata tekstistä haluamasi kohdat hiirellä ja kopioida sen leikepöydälle (ctrl-c).</p>
        <textarea v-model='clipboardText' rows="16" class="col-12 h5"></textarea>
      </template>
      <template slot="footer">
        <v-button type="button" variant="primary" @click="closeContentModal">Sulje</v-button>
      </template>
    </modal>

    <modal v-show="isQuestionnaireModalVisible" variant="medium" @close="closeQuestionnaireModal">
      <template slot="header">Sulje keskustelu</template>
      <template slot="body">
        <div class="left-align">
          <div class="mb2 semibold">Miten hoito jatkuu?</div>
          <form>
            <label v-for="selection in selections" class="custom-control custom-radio" :key="selection">
              <input type="radio" name="questionnaire" v-model="selectedSelection" :value="selection">
              <span class="custom-control-indicator"></span>
              <span>{{selection}}</span>
            </label>
            <textarea v-if="selectedSelection" placeholder="Muita huomioita" v-model="details" rows="6" class="col-12"></textarea>
          </form>
        </div>
      </template>
      <template slot="footer">
        <div class="mr2">
          <v-button type="button" @click="closeQuestionnaireModal">Peruuta</v-button>
        </div>
        <v-button type="button" @click="close" :disabled="selectedSelection.length === 0 || (selectedSelection === selections[selections.length - 1] && !details)" variant="primary">Sulje keskustelu</v-button>
      </template>
    </modal>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import Button from '@/components/Button.vue';
import Util from '@/util';
import moment from 'moment';

export default {
  name: 'RightFooter',
  data () {
    return {
      isQuestionnaireModalVisible: false,
      isContentModalVisible: false,
      content: '',
      selections: ['Hoidettu etähoitona, tilanne ei vaadi muita toimenpiteitä.',
      'Hoidettu etähoitona, ohjeistettu ottamaan yhteyttä mikäli tarvetta.',
      'Hoidettu etähoitona ja annettu lääkemääräys apteekkiin/haku klinikalta.',
      'Etähoito mahdollinen, mutta tilanne vaatii myös lääkehoidon. Ohjattu klinikalle.', 
      'Eläimen tila vaatii lisätutkimuksia, ohjattu jatkohoitoon kiireettömästi.',
      'Eläimen tila vaatii välitöntä hoitoa, ohjattu päivystykseen.',
      'Muu tilanne, mikä? (lisää selvitys kenttään)'],
      selectedSelection: '',
      details: '',
    };
  },
  components: {
    Modal,
    'v-button': Button
  },
  props: {
    chat: Object,
    messages: Array,
  },
  computed: {
    ...mapGetters({
      profile: 'profile',
    }),
    clipboardText: {
      get() {
        return this.messages.reduce((clipboard, message) => {
          if (message.category === 'note') {
            return clipboard + '-------- ' + message.message + ' ' + this.addTime(message.createdAt) + ' --------' + '\r\n';
          } else {
            return clipboard + this.getName(message, this.chat) + ': ' + message.message + '\r\n';
          }
        }, '');
      },
      set(value) {
        //do nothing
      }
    }
  },
  methods: {
    getName (message, chat) {
      if (message.userId === chat.userId) {
        return chat.userName;
      }
      return Util.getPractitionerName(chat.practitioners, message);
    },
    addTime (date) {
      if (!date) return '';
      const parsedDate = moment(date);
      const dateString = parsedDate.format('D.M.YYYY');
      const timeString = parsedDate.format('HH:mm');
      return `${dateString} klo ${timeString}`;
    },
    assign: function() {
      this.$store.dispatch('assignChat', this.chat.chatId);
    },
    close: function() {
      this.$store.dispatch('closeChat', {
        chatId: this.chat.chatId,
        selection: this.selectedSelection,
        details: this.details,
      });
      this.isCloseChatModalVisible = false;
    },
    queueSession: function() {
      this.$store.dispatch('queueChat', this.chat.chatId);
    },
    showQuestionnaireModal() {
      this.isQuestionnaireModalVisible = true;
    },
    closeQuestionnaireModal() {
      this.isQuestionnaireModalVisible = false;
    },
    showContentModal() {
      this.isContentModalVisible = true;
    },
    closeContentModal() {
      this.isContentModalVisible = false;
    }
  },
  mounted() {
  },
};
</script>

<style scoped>
  .action {
    margin: 0;
    padding: .75rem var(--space-2);
    border: none;
    background: var(--white);
    color: var(--blue);
    font-size: var(--h5);
    text-align: left;
    cursor: pointer;
    border-top: 1px solid var(--gray-4);
  }

  .action svg {
    display: inline-block;
    vertical-align: middle;
    margin-right: .5rem;
  }

  .action:hover,
  .action:active,
  .action:focus { background-color: var(--gray-6) }

  .action:active,
  .action:focus { outline: none }

  .action:disabled,
  .action.disabled {
    cursor: default;
    color: var(--gray-3);
  }
  .action:disabled svg g { stroke: var(--gray-3) }
  .action:disabled:hover,
  .action.disabled:hover {
    background-color: var(--white);
  }

  .custom-control {
    position: relative;
    display: block;
    padding-bottom: var(--space-1);
    padding-left: var(--space-3);
    cursor: pointer;
    line-height: var(--line-height-4);
    font-weight: normal;
  }

  .custom-control input[type=radio] {
    position: absolute;
    opacity: 0;
    z-index: -1;
  }

  .custom-control input[type=radio]:checked~.custom-control-indicator {
    color: var(--white);
    background-color: var(--blue);
    box-shadow: none;
    background-image: url("data:image/svg+xml,%3Csvg%20width%3D%2213%22%20height%3D%228%22%20viewBox%3D%220%200%2013%208%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M1%204.5L4.5%208l8-8%22%20stroke%3D%22%23FFF%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E");
  }

  .custom-control-indicator {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 1.375rem;
    height: 1.375rem;
    line-height: 1.375rem;
    font-size: 65%;
    text-align: center;
    border-radius: 99px;
    background-color: var(--gray);
    background-repeat: no-repeat;
    background-position: center;
  }

  .custom-control:hover .custom-control-indicator {
    background-color: var(--gray-4);
  }
</style>
